"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deductZeroMembership = exports.valueToDefault = exports.hasTruthyValue = exports.areAllTruthy = exports.getFLPSubscriptionAndDuration = exports.getOrganizationCurrencyType = exports.parseType = exports.isSubscriptionExtended = exports.isFLPSubscriptionRenewed = exports.isSubscriptionRenewed = exports.getNextEndDate = exports.isShortPeriod = exports.getFuturePeriod = exports.getCurrentPeriod = exports.getNewSubscriptionAccessStartDate = exports.getMaxStartDate = exports.getMaxEndDate = exports.getMaxEndDatePure = exports.isAfterExpirationThreshold = exports.isPositionChangeLocked = exports.isQuoteWithHiddenItems = exports.isCleanable = exports.isResettable = exports.cleanableItemOptions = exports.resettableItemOptions = exports.getQuoteItemSku = exports.getQuoteItemPrice = exports.isAllItemActions = exports.isExtensionQuoteItem = exports.isNewQuoteItem = exports.isEndDateIsForRenewal = exports.isUpdateQuoteItem = exports.isUpgradeQuoteItem = exports.isRenewalQuoteItem = exports.isNewSubscriptionQuoteItem = exports.isExistingSubscriptionQuoteItem = exports.isQuoteItemOwnerWithoutRenewal = void 0;
const cart_1 = require("../cart");
const mxp_schemas_1 = require("mxp-schemas");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const MONTHS_WITHOUT_PRORATION = 3;
const SUBSCRIPTION_EXPIRATION_THRESHOLD_DAYS = 90;
const isQuoteItemOwnerWithoutRenewal = (quoteItem) => {
    return (quoteItem.action === mxp_schemas_1.User.QuoteItemActions.OWNER &&
        (!quoteItem.isIncludedInFirmBilling || (0, exports.isSubscriptionRenewed)(quoteItem.renewalDate)));
};
exports.isQuoteItemOwnerWithoutRenewal = isQuoteItemOwnerWithoutRenewal;
const isExistingSubscriptionQuoteItem = (item) => Boolean(item.subscriptionNumber);
exports.isExistingSubscriptionQuoteItem = isExistingSubscriptionQuoteItem;
const isNewSubscriptionQuoteItem = (item) => !(0, exports.isExistingSubscriptionQuoteItem)(item);
exports.isNewSubscriptionQuoteItem = isNewSubscriptionQuoteItem;
const isRenewalQuoteItem = (item, endDate, isFlpItem) => ((0, exports.isExistingSubscriptionQuoteItem)(item) &&
    item.isIncludedInFirmBilling &&
    !(0, exports.isExtensionQuoteItem)(item, endDate) &&
    !(0, exports.isSubscriptionRenewed)(item.renewalDate)) ||
    isFlpRenewalQuoteItem(item, isFlpItem);
exports.isRenewalQuoteItem = isRenewalQuoteItem;
const isFlpRenewalQuoteItem = (item, isFlpItem) => isFlpItem && (0, exports.isExistingSubscriptionQuoteItem)(item) && item.isIncludedInFirmBilling && !Boolean(item.newVariantSku);
const isUpgradeQuoteItem = (item) => (0, exports.isExistingSubscriptionQuoteItem)(item) && Boolean(item.newVariantSku);
exports.isUpgradeQuoteItem = isUpgradeQuoteItem;
const isUpdateQuoteItem = (item, flpRenewalSeasonOpen, isFLPProduct) => isFLPProduct &&
    (0, exports.isExistingSubscriptionQuoteItem)(item) &&
    Boolean(item === null || item === void 0 ? void 0 : item.newVariantSku) &&
    Boolean(item === null || item === void 0 ? void 0 : item.isUpdateRenewal) &&
    (0, exports.isEndDateIsForRenewal)((0, moment_timezone_1.default)(item === null || item === void 0 ? void 0 : item.renewalDate), flpRenewalSeasonOpen);
exports.isUpdateQuoteItem = isUpdateQuoteItem;
const isEndDateIsForRenewal = (renewalDate, flpRenewalSeasonOpen) => {
    const now = (0, moment_timezone_1.default)();
    const duration = moment_timezone_1.default.duration(now.diff(renewalDate));
    const days = duration.asDays();
    return days <= Number(flpRenewalSeasonOpen);
};
exports.isEndDateIsForRenewal = isEndDateIsForRenewal;
const isNewQuoteItem = (item, endDate, isFlpItem) => (!(0, exports.isRenewalQuoteItem)(item, endDate, isFlpItem) && !(0, exports.isUpgradeQuoteItem)(item)) ||
    (!(0, exports.isRenewalQuoteItem)(item, endDate, isFlpItem) && !(0, exports.isUpgradeQuoteItem)(item) && Boolean(item.newVariantSku));
exports.isNewQuoteItem = isNewQuoteItem;
const isExtensionQuoteItem = (item, endDate) => (0, exports.isUpgradeQuoteItem)(item) && !(0, exports.isSubscriptionExtended)(item.renewalDate, endDate);
exports.isExtensionQuoteItem = isExtensionQuoteItem;
const isAllItemActions = (quoteGroups, action) => !quoteGroups.some(g => g.quoteItems.some(item => item.action !== action));
exports.isAllItemActions = isAllItemActions;
const getQuoteItemPrice = (item) => item.newCentPrice || item.centPrice;
exports.getQuoteItemPrice = getQuoteItemPrice;
const getQuoteItemSku = (item) => item.newVariantSku || item.variantSku;
exports.getQuoteItemSku = getQuoteItemSku;
exports.resettableItemOptions = [mxp_schemas_1.User.FirmBillingQuoteItemOptions.RESETTABLE];
exports.cleanableItemOptions = [
    mxp_schemas_1.User.FirmBillingQuoteItemOptions.RESETTABLE,
    mxp_schemas_1.User.FirmBillingQuoteItemOptions.READY,
];
const isResettable = (option) => exports.resettableItemOptions.includes(option || mxp_schemas_1.User.FirmBillingQuoteItemOptions.READY);
exports.isResettable = isResettable;
const isCleanable = (option) => exports.cleanableItemOptions.includes(option || mxp_schemas_1.User.FirmBillingQuoteItemOptions.READY);
exports.isCleanable = isCleanable;
const isQuoteWithHiddenItems = (quoteItems) => (quoteItems || []).some(item => item.options === mxp_schemas_1.User.FirmBillingQuoteItemOptions.HIDDEN);
exports.isQuoteWithHiddenItems = isQuoteWithHiddenItems;
const isPositionChangeLocked = (quoteStatus, isRenewalSeason, quoteItems, isHonorary) => !!isHonorary ||
    !isRenewalSeason ||
    quoteStatus === mxp_schemas_1.User.FirmBillingQuoteStatus.QUOTE_GENERATED ||
    (quoteItems || []).some(item => !(0, exports.isCleanable)(item.options) && !(item.options === mxp_schemas_1.User.FirmBillingQuoteItemOptions.NOT_RESETTABLE));
exports.isPositionChangeLocked = isPositionChangeLocked;
const isAfterExpirationThreshold = (expiryDate, flpRenewalSeasonOpen) => {
    if (expiryDate === null)
        return false;
    const daysLeftUntilExpiration = (0, moment_timezone_1.default)(expiryDate).diff((0, moment_timezone_1.default)(), 'days');
    if (!!flpRenewalSeasonOpen)
        return parseInt(flpRenewalSeasonOpen, 10) < daysLeftUntilExpiration;
    return SUBSCRIPTION_EXPIRATION_THRESHOLD_DAYS < daysLeftUntilExpiration;
};
exports.isAfterExpirationThreshold = isAfterExpirationThreshold;
const getMaxEndDatePure = (dates) => dates.length
    ? (0, moment_timezone_1.default)(Math.max.apply(null, Object.values(dates)
        .map(d => (d.endDate ? (0, moment_timezone_1.default)(d.endDate) : null))
        .filter(Boolean)))
        .add(1, 'days')
        .format('YYYY-MM-DD')
    : null;
exports.getMaxEndDatePure = getMaxEndDatePure;
const getMaxEndDate = (quotes) => {
    const dates = quotes.reduce((acc, quote) => {
        quote.quoteItems.forEach(item => {
            if (item.updatedSubscriptionEndDate)
                acc.push({ endDate: item.updatedSubscriptionEndDate });
        });
        return acc;
    }, []);
    return (0, exports.getMaxEndDatePure)(dates);
};
exports.getMaxEndDate = getMaxEndDate;
const getMaxStartDate = (quotes) => {
    const dates = quotes.reduce((acc, quote) => {
        quote.quoteItems.forEach(item => {
            if (item.updatedSubscriptionStartDate)
                acc.push({ endDate: item.updatedSubscriptionStartDate });
        });
        return acc;
    }, []);
    return (0, exports.getMaxEndDatePure)(dates);
};
exports.getMaxStartDate = getMaxStartDate;
const getNewSubscriptionAccessStartDate = (quotes, subscriptionNewAccessStartDate, isFLP) => {
    return isFLP && !subscriptionNewAccessStartDate ? (0, exports.getMaxStartDate)(quotes) : subscriptionNewAccessStartDate;
};
exports.getNewSubscriptionAccessStartDate = getNewSubscriptionAccessStartDate;
const getCurrentPeriod = (endDate) => (0, moment_timezone_1.default)().add(cart_1.NUMBER_OF_MONTHS_BEFORE_PRODUCT_START_MONTH_DO_WE_RENEW_IN_LAST_YEAR, 'months') > endDate
    ? endDate.clone()
    : endDate.clone().add(-1, 'year'); // renewal season for the year before closes 5 months before the next season starts
exports.getCurrentPeriod = getCurrentPeriod;
const getFuturePeriod = (endDate) => (0, exports.getCurrentPeriod)(endDate).add(1, 'year');
exports.getFuturePeriod = getFuturePeriod;
const isShortPeriod = (endDate) => Math.ceil((0, exports.getCurrentPeriod)(endDate).diff((0, moment_timezone_1.default)(), 'month', true)) <= MONTHS_WITHOUT_PRORATION;
exports.isShortPeriod = isShortPeriod;
const getNextEndDate = (productDate) => {
    const endDate = (0, exports.getCurrentPeriod)(productDate);
    return endDate.isAfter((0, moment_timezone_1.default)()) ? endDate : endDate.add(1, 'year');
};
exports.getNextEndDate = getNextEndDate;
const isSubscriptionRenewed = (endDate) => {
    const membershipDiffMonths = (0, moment_timezone_1.default)(endDate).diff((0, moment_timezone_1.default)(), 'months');
    const isExpiryYearGreaterThanCurrentYear = (0, moment_timezone_1.default)(endDate, 'YYYY-MM-DD').year() > (0, moment_timezone_1.default)().year();
    const isExpiryYearEqualCurrentYear = (0, moment_timezone_1.default)(endDate, 'YYYY-MM-DD').year() === (0, moment_timezone_1.default)().year();
    return (isExpiryYearGreaterThanCurrentYear ||
        (isExpiryYearEqualCurrentYear && membershipDiffMonths >= MONTHS_WITHOUT_PRORATION));
};
exports.isSubscriptionRenewed = isSubscriptionRenewed;
const isFLPSubscriptionRenewed = (subscriptionStartDate, duration) => (0, moment_timezone_1.default)(subscriptionStartDate, 'YYYY-MM-DD').add(Number(duration), 'm').isAfter((0, moment_timezone_1.default)().year());
exports.isFLPSubscriptionRenewed = isFLPSubscriptionRenewed;
const isSubscriptionExtended = (endDate, endDateObj) => (0, moment_timezone_1.default)(endDate, 'YYYY-MM-DD').diff((0, exports.getFuturePeriod)(endDateObj)) >= 0;
exports.isSubscriptionExtended = isSubscriptionExtended;
const parseType = (type) => {
    if (type === mxp_schemas_1.B2B.OrganizationCapabilityType.CIMA) {
        return {
            ct: mxp_schemas_1.Product.ProductMembershipBody.CIMA,
            sf: mxp_schemas_1.Salesforce.LegalEntity.CIMA,
            zuora: mxp_schemas_1.ZuoraTypes.EntityName.UK_CIMA,
            user: mxp_schemas_1.User.MembershipType.CIMA,
            zuoraLegalEntity: mxp_schemas_1.ZuoraTypes.LegalEntity.CIMA,
        };
    }
    return {
        ct: mxp_schemas_1.Product.ProductMembershipBody.AICPA,
        sf: mxp_schemas_1.Salesforce.LegalEntity.ASSOCIATION,
        zuora: mxp_schemas_1.ZuoraTypes.EntityName.US_AICPA,
        user: mxp_schemas_1.User.MembershipType.AICPA,
        zuoraLegalEntity: mxp_schemas_1.ZuoraTypes.LegalEntity.ASSOCIATION,
    };
};
exports.parseType = parseType;
const getOrganizationCurrencyType = (org) => (org === null || org === void 0 ? void 0 : org.SFS_ACC_FBCIMA__c) ? mxp_schemas_1.Product.ProductCurrencyLabel.GBP : mxp_schemas_1.Product.ProductCurrencyLabel.USD;
exports.getOrganizationCurrencyType = getOrganizationCurrencyType;
const getFLPSubscriptionAndDuration = (subscriptions, slug, duration) => {
    var _a;
    const subscription = subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.find((sub) => sub.slug === slug);
    if (subscription) {
        return { type: subscription === null || subscription === void 0 ? void 0 : subscription.name, duration: `${duration ? `${duration} Months` : 'N/A'}` };
    }
    // some members still have an SKU in place of a slug
    const subscriptionBySku = subscriptions.find(subs => subs === null || subs === void 0 ? void 0 : subs.variants.find(variant => (variant === null || variant === void 0 ? void 0 : variant.sku) === slug));
    if (subscriptionBySku) {
        const variant = (_a = subscriptionBySku === null || subscriptionBySku === void 0 ? void 0 : subscriptionBySku.variants) === null || _a === void 0 ? void 0 : _a.find((sub) => sub.sku === slug);
        return { type: subscriptionBySku === null || subscriptionBySku === void 0 ? void 0 : subscriptionBySku.name, duration: `${variant === null || variant === void 0 ? void 0 : variant.flpTerm} Months` };
    }
    return { type: 'N/A', duration: 'N/A' };
};
exports.getFLPSubscriptionAndDuration = getFLPSubscriptionAndDuration;
const areAllTruthy = (...args) => {
    return args.every(value => value);
};
exports.areAllTruthy = areAllTruthy;
const hasTruthyValue = (...args) => {
    return args.some(value => value);
};
exports.hasTruthyValue = hasTruthyValue;
const valueToDefault = (value, defaultVal) => {
    return value || defaultVal;
};
exports.valueToDefault = valueToDefault;
// deduct new memberships with zero price from totalPrice since cart totalPrice does not exclude products with zero price
const deductZeroMembership = (cart) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    // check if there are new members
    const hasNewMembers = (_a = cart.lineItems) === null || _a === void 0 ? void 0 : _a.find((lineItem) => (lineItem === null || lineItem === void 0 ? void 0 : lineItem.productSlug) === mxp_schemas_1.Product.Fee.CIMA_JOINING_FEE);
    const totalCost = cart.totalPrice.centAmount;
    const totalDiscountedAmount = (0, cart_1.calculateCartDiscount)(cart, true);
    if (!hasNewMembers) {
        return { totalCost, totalDiscountedAmount };
    }
    const newMemberQuantity = (_b = hasNewMembers === null || hasNewMembers === void 0 ? void 0 : hasNewMembers.quantity) !== null && _b !== void 0 ? _b : 1;
    const hasCimaCandidate = (_c = cart.lineItems) === null || _c === void 0 ? void 0 : _c.find((lineItem) => (lineItem === null || lineItem === void 0 ? void 0 : lineItem.productSlug) === mxp_schemas_1.MembershipTypes.CimaMembershipProductSlug.CIMA_CANDIDATE_PRODUCT);
    // if discount code includes CIMA candidate membership, deduct discounted price amount
    // else, deduct full candidate price amount
    const candidatePrice = (_d = hasCimaCandidate === null || hasCimaCandidate === void 0 ? void 0 : hasCimaCandidate.basePrice.value.centAmount) !== null && _d !== void 0 ? _d : 0;
    const discountedPrice = (_j = (_h = (_g = (_f = (_e = hasCimaCandidate === null || hasCimaCandidate === void 0 ? void 0 : hasCimaCandidate.discountedPricePerQuantity) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.discountedPrice) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.centAmount) !== null && _j !== void 0 ? _j : candidatePrice;
    // get discountedAmount if discount code includes CIMA candidate membership
    const discountAmount = (_r = (_q = (_p = (_o = (_m = (_l = (_k = hasCimaCandidate === null || hasCimaCandidate === void 0 ? void 0 : hasCimaCandidate.discountedPricePerQuantity) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.discountedPrice) === null || _m === void 0 ? void 0 : _m.includedDiscounts) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.discountedAmount) === null || _q === void 0 ? void 0 : _q.centAmount) !== null && _r !== void 0 ? _r : 0;
    const totalNewMemberDiscountedPrice = discountedPrice * newMemberQuantity;
    const totalNewMemberDiscountAmount = discountAmount * newMemberQuantity;
    return {
        totalCost: totalCost - totalNewMemberDiscountedPrice,
        totalDiscountedAmount: totalDiscountedAmount - totalNewMemberDiscountAmount,
    };
};
exports.deductZeroMembership = deductZeroMembership;
//# sourceMappingURL=index.js.map